export default {
  menu: {
    SystemName: 'System Name',
    MenuNameCn: 'Menu Name(Cn)',
    MenuNameEn: 'Menu Name(En)',
    MenuCode: 'Menu Code',
    Parent: 'Parent',
    ChooseParent: 'Choose Parent',
    ParentName: 'Parent Name',
    Asp: 'Asp',
    SystemId: 'System Id',
    Default: 'Default',
    Catalog: 'Catalog',
    Link: 'Link',
    IconsUrl: 'Icons Upload',
    ComponentUrl: 'Component Url',
    HiddenFlag: 'Hidden Flag',
    MatchPath: 'Match Path',
    ChooseSystem: 'Choose System',
    PleaseChooseSystem: 'Please Choose System'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/base/menu.js